<template>
    <button id="back-btn" @click="$router.back">&leftarrow; Go back</button>
</template>